/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Key_Property_UpdateInputs */

const cs_audit_key_property_update = /** @type {(inputs: Audit_Key_Property_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost upravena`)
};

const en_audit_key_property_update = /** @type {(inputs: Audit_Key_Property_UpdateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property updated`)
};

/**
* | output |
* | --- |
* | "Property updated" |
*
* @param {Audit_Key_Property_UpdateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const audit_key_property_update = /** @type {((inputs?: Audit_Key_Property_UpdateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Key_Property_UpdateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_key_property_update(inputs)
	return cs_audit_key_property_update(inputs)
});